import { formElement } from "../../forms/FormElement";
import PermitAgreementFormState from "../../forms/Permits/EnergyHarbourPermit/PermitAgreementFormState";
import Signature from "../../Signature";

type PermitAgreement = {
    startDate: Date;
    endDate: Date;
    fireGuard: string | undefined;
    wayOfCommunication: string | undefined;
    permitAgreementProviderSignature: Signature;
    permitAgreementSeekerSignature: Signature;
    isColdWorkOnly: boolean;
};

export default PermitAgreement;

export function PermitAgreement_toFormState(permitAgreement: PermitAgreement): PermitAgreementFormState {
    return {
        startDate: formElement(permitAgreement.startDate),
        endDate: formElement(permitAgreement.endDate),
        fireGuard: formElement(permitAgreement.fireGuard),
        wayOfCommunication: formElement(permitAgreement.wayOfCommunication),
        isColdWorkOnly: formElement(permitAgreement.isColdWorkOnly),
    };
}
